import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import DayPicker from 'react-day-picker';

import 'react-day-picker/lib/style.css';
import './DatePicker.css';

// simple decoration of "DayPicker" library:
//  just wrap DayPicker and pass along unmanaged props
const DatePicker = ({ className, ...props }) => {
  const containerClass = cx('zola-ui', 'zola-ui__datepicker', className);

  return (
    <div className={containerClass}>
      <DayPicker {...props} />
    </div>
  );
};

DatePicker.propTypes = {
  className: PropTypes.string,
};

export default DatePicker;
